import React from 'react';
import Layout from './layout/Layout';


const App = () => {
  return <Layout />;
};

export default App;
